import { Injectable } from '@angular/core';
import {salesChannel} from '../../core/utils/utils';
import {BannersPartnerConfig, CustomBannerConfig, StepBannerConfig} from '../../core/models/banners-partner-config';
import {BANNERS_CONFIG} from '../../core/configs/banners-config';

@Injectable({
  providedIn: 'root'
})
export class BannersService {

  driverSosDescriptionsConfig: DriverSosDescription[] = [
    {
      imageUrl: './assets/images/banners/driver-sos-details-1.svg',
      letter: 'S.',
      text: 'BANNER.DRIVER_SOS_DETAILS.description1'
    },
    {
      imageUrl: './assets/images/banners/driver-sos-details-2.svg',
      letter: 'O.',
      text: 'BANNER.DRIVER_SOS_DETAILS.description2'
    },
    {
      imageUrl: './assets/images/banners/driver-sos-details-3.svg',
      letter: 'S.',
      text: 'BANNER.DRIVER_SOS_DETAILS.description3'
    }
  ];

  private config: BannersPartnerConfig;

  get htmlBannersEnabled(): boolean {
    return !!this.config && !this.config.htmlBannersDisabled;
  }


  get offersListBannerConfig(): CustomBannerConfig {
    return this.htmlBannersEnabled ? this.config.offersListBanner : null;
  }

  get paymentBannerVisible(): boolean {
    return this.htmlBannersEnabled ? !!this.config.paymentBanner : false;
  }

  constructor() {
    this.initConfig();
  }

  getStepBannerConfig(stepKey: string): StepBannerConfig {
    return (this.hasStepsConfig && !!stepKey) ? this.config.stepBanners.find(config => config.stepKey === stepKey) : null;
  }

  private initConfig() {
    this.config = BANNERS_CONFIG.find(config => config.partnerName === salesChannel());
  }

  get hasStepsConfig(): boolean {
    return this.htmlBannersEnabled && !!this.config.stepBanners && !!this.config.stepBanners.length;
  }
}

export interface DriverSosDescription {
  imageUrl: string;
  letter: string;
  text: string;
}
